import { useState } from 'react';

interface CopyButtonProps {
  text: string;
  /** Accessible name; defaults to "Copy <text>", which only suits short text. */
  label?: string;
}

export function CopyButton({ text, label }: CopyButtonProps) {
  const [state, setState] = useState<'idle' | 'success' | 'failed'>('idle');

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setState('success');
    } catch {
      setState('failed');
    }
    setTimeout(() => setState('idle'), 2000);
  };

  return (
    <button
      type="button"
      className={`copy-button ${state !== 'idle' ? `copy-${state}` : ''}`}
      onClick={() => void copy()}
      aria-label={label ?? `Copy ${text}`}
    >
      {state === 'idle' ? 'Copy' : state === 'success' ? 'Copied!' : 'Failed'}
    </button>
  );
}
